import actions from '../../actions/DentalBenefitsSets'
import { connectPlanSharedBusinessRules } from '../PlanSharedBusinessRules/CreateBusinessRulesShow'

export default connectPlanSharedBusinessRules('Dental', actions.show.main, actions.show.reset)
